import { styled } from '../styled'
import FormFieldError from './FormFieldError'

const FormError = styled(FormFieldError)`
  text-align: left;
`

export default FormError
